<crm-tree-select
  class="block {{ styleClass }}{{ isError ? ' ng-invalid ng-dirty' : '' }}"
  [options]="options"
  [(selectedItem)]="selectedDocumentType"
  (selectedItemChange)="selectedDocumentTypeChange.emit($event)"
  [showClear]="showClear"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [groupsDisabled]="true"
  dataKey="code"
  display="comma"
  selectionMode="single">
</crm-tree-select>
